export default __webpack_public_path__ + "static/media/declined_regular.3d471dac.gif";